import { render, staticRenderFns } from "./table-history-item.vue?vue&type=template&id=732111e1&scoped=true"
import script from "./table-history-item.vue?vue&type=script&lang=js"
export * from "./table-history-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732111e1",
  null
  
)

export default component.exports